import type { ImageProps } from 'vant'
import VantImage from 'vant/lib/image'
import VantLoading from 'vant/lib/loading'
import 'vant/lib/image/index.css'
import 'vant/lib/loading/index.css'
import { getImageUrl } from '@/utils'

// const imageProps = {
//   src: String,
//   alt: String,
//   fit: String,
//   position: String,
//   round: Boolean,
//   block: Boolean,
//   width: Number,
//   height: Number,
//   radius: Number,
//   lazyLoad: Boolean,
//   iconSize: Number,
//   showError: Boolean,
//   errorIcon: String,
//   iconPrefix: String,
//   showLoading: Boolean,
//   loadingIcon: String,
//   crossorigin: String,
//   referrerpolicy: String,
// };

// export default defineComponent({
//   name: 'Image',
//   props: imageProps,
//   emits: ['click'],
//   setup(props: Partial<ImageProps> & { onClick?: (event: MouseEvent) => void }, { slots, emit }: { slots: any, emit: any }) {
//     const handleClick = (event: MouseEvent) => {
//       emit('click', event);
//     };
    
//     const imgSrc = props.src ? getImageUrl(props.src) : ''

//     return () => (
//       <VantImage
//         {...props}
//         src={imgSrc}
//         onClick={ handleClick }
//         v-slots={{
//           loading: () => slots.loading?.(),
//           error:   () => slots.error?.()
//         }}/>
//     );
//   }
// }); 

export default function Image(props: Partial<ImageProps> & { onClick?: (event: MouseEvent) => void, class?: any }, { slots }: { slots: any }) {
  const imgSrc = props.src ? getImageUrl(props.src) : ''

  return (
    <VantImage
      {...props}
      src={imgSrc}
      v-slots={{
        loading: () => slots.loading?.() || <VantLoading type="spinner" size="20" />,
        error:   () => slots.error?.() || null
      }}/>
  )
}
